module.exports = __webpack_public_path__ + "img/1fie-n-shkulat.e94dc6f9.jpg";